var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar',{key:_vm.$route.fullPath}),_c('TopBackground'),_c('v-main',{staticStyle:{"background":"#f6f9fc"}},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('CookieConsent'),_c('v-footer',{attrs:{"padless":true}},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }